import script from "./CurrentMonth.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentMonth.vue?vue&type=script&setup=true&lang=js"

import "./CurrentMonth.vue?vue&type=style&index=0&id=bcd8e08c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcd8e08c"]])

export default __exports__